import { render, staticRenderFns } from "./ActionDetails.vue?vue&type=template&id=a236331a&"
import script from "./ActionDetails.vue?vue&type=script&lang=js&"
export * from "./ActionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports